
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/psychoeds",
      function () {
        return require("private-next-pages/psychoeds/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/psychoeds"])
      });
    }
  